import BackboneElement from './BackboneElement';
import CodeableConcept from './types/CodeableConcept';
import Quantity from './types/Quantity';
import Range from './types/Range';

import merge from 'lodash/merge';

export default class ObservationReferenceRange extends BackboneElement {
    static __className = 'ObservationReferenceRange';

    __objectStructure = {
        low: Quantity,
        high: Quantity,
        type: CodeableConcept,
        appliesTo: [CodeableConcept],
        age: Range,
        text: String,
    };

    constructor(constructJson, className = 'ObservationReferenceRange') {
        super(constructJson, className);

        this.createAndPopulateStructure(this.__objectStructure, constructJson);

        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
